import React from 'react'
import styled from 'styled-components'
import { Box } from '@chakra-ui/react'

const Wrapper = styled(Box)`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 320px;
`

const Changelog = styled.iframe`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 320px;
`

const NotificationLayout = (): React.ReactElement => (
  <Wrapper>
    <Changelog
      title="changelog"
      src="https://changelog.imagekit.io/?utm_medium=widget"
    />
  </Wrapper>
)

export default NotificationLayout
